import {
  SET_EMAIL_ADDRESS,
  SET_IS_EMAIL_AUTHENTICATION,
  SET_IS_EMAIL_REGISTRATION,
  SET_IS_REGISTERING,
  SET_PHONE_NUMBER,
  SET_RESTART_LINK_PATH,
  SetEmailAddressAction,
  SetIsEmailAuthenticationAction,
  SetIsEmailRegistrationAction,
  SetIsRegisteringAction,
  SetPhoneNumberAction,
  SetRestartLinkPathAction,
  UPDATE_AUTH_PROGRESS,
  UpdateAuthProgressAction,
} from '../actions/authProgress';
import DEFAULT_STATE, { AuthProgressState } from '../defaults/authProgress';
import createReducer from './create-reducer';

function setPhoneNumber(state: AuthProgressState, { phoneNumber }: SetPhoneNumberAction) {
  return {
    ...state,
    phoneNumber,
  };
}

function setEmailAddress(state: AuthProgressState, { emailAddress }: SetEmailAddressAction) {
  return {
    ...state,
    emailAddress,
  };
}

function setIsRegistering(state: AuthProgressState, { isRegistering }: SetIsRegisteringAction) {
  return {
    ...state,
    isRegistering,
  };
}

function setIsEmailAuthentication(
  state: AuthProgressState,
  { isEmailAuthentication }: SetIsEmailAuthenticationAction,
) {
  return {
    ...state,
    isEmailAuthentication,
  };
}

function setRestartLinkPath(
  state: AuthProgressState,
  { restartLinkPath }: SetRestartLinkPathAction,
) {
  return {
    ...state,
    restartLinkPath,
  };
}

function setIsEmailRegistration(
  state: AuthProgressState,
  { isEmailRegistration }: SetIsEmailRegistrationAction,
) {
  return {
    ...state,
    isEmailRegistration,
  };
}

function updateAuthProgress(state: AuthProgressState, { payload }: UpdateAuthProgressAction) {
  return {
    ...state,
    ...payload,
  };
}

const handlers = {
  [SET_PHONE_NUMBER]: setPhoneNumber,
  [SET_EMAIL_ADDRESS]: setEmailAddress,
  [SET_IS_REGISTERING]: setIsRegistering,
  [SET_IS_EMAIL_AUTHENTICATION]: setIsEmailAuthentication,
  [SET_RESTART_LINK_PATH]: setRestartLinkPath,
  [SET_IS_EMAIL_REGISTRATION]: setIsEmailRegistration,
  [UPDATE_AUTH_PROGRESS]: updateAuthProgress,
};

export default createReducer(DEFAULT_STATE, handlers);
